<nz-skeleton [nzActive]="true" [nzLoading]="loading" class="font-roboto-600">
  <ng-container *ngIf="lineUp && lineUp.status">
    <!-- STARTING LINEUPS -->
    <div
      class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3"
    >
      {{ "StartingLineups" | translate }}
    </div>
    <div class="grid grid-cols-2 gap-5">
      <div class="flex flex-col gap-5">
        <ng-container
          *ngFor="let players of lineUp.lineup.homeTitular; let i = index"
        >
          <div class="flex gap-2 items-center">
            <div class="max-w-[20px] w-full text-16 text-grey-2">
              {{ players.shirt_number }}
            </div>
            <img
              alt="logo"
              class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
              [src]="players.logo"
            />
            <div class="text-14">
              {{ transform(players.name, 15) }}
            </div>
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="
                  (incident.player &&
                    incident.player.id === players.id &&
                    incident.type === 1) ||
                  incident.type === 8 ||
                  incident.type === 16 ||
                  incident.type === 17 ||
                  incident.type === 29 ||
                  incident.type === 30
                "
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <img
                alt="logo"
                *ngIf="incident.type === 3 || incident.type === 4"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
            </ng-container>
          </div>
          <div class="flex gap-2 items-center" *ngIf="players.incidents">
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="incident.type === 9"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <div class="text-14" *ngIf="incident.type === 9">
                ({{ transform(incident.in_player.name, 15) }})
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="flex flex-col gap-5">
        <ng-container
          *ngFor="let players of lineUp.lineup.awayTitular; let i = index"
        >
          <div class="flex flex-row-reverse gap-2 items-center">
            <div class="max-w-[20px] w-full text-16 text-grey-2">
              {{ players.shirt_number }}
            </div>
            <img
              alt="logo"
              class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
              [src]="players.logo"
            />
            <div class="text-14">
              {{ transform(players.name, 15) }}
            </div>
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="
                  (incident.player &&
                    incident.player.id === players.id &&
                    incident.type === 1) ||
                  incident.type === 8 ||
                  incident.type === 16 ||
                  incident.type === 17 ||
                  incident.type === 29 ||
                  incident.type === 30
                "
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <img
                alt="logo"
                *ngIf="incident.type === 3 || incident.type === 4"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
            </ng-container>
          </div>
          <div
            class="flex flex-row-reverse gap-2 items-center"
            *ngIf="players.incidents"
          >
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="incident.type === 9"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <div class="text-14" *ngIf="incident.type === 9">
                ({{ transform(incident.in_player.name, 15) }})
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- SUBSTITUTE -->
    <div
      class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3 mt-5"
    >
      {{ "Substitute" | translate }}
    </div>
    <div class="grid grid-cols-2 gap-5">
      <div class="flex flex-col gap-5">
        <ng-container
          *ngFor="let players of lineUp.lineup.homeSubstitutes; let i = index"
        >
          <div class="flex gap-2 items-center">
            <div class="max-w-[20px] w-full text-16 text-grey-2">
              {{ players.shirt_number }}
            </div>
            <img
              alt="logo"
              class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
              [src]="players.logo"
            />
            <div class="text-14">
              {{ transform(players.name, 15) }}
            </div>
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="
                  (incident.player &&
                    incident.player.id === players.id &&
                    incident.type === 1) ||
                  incident.type === 8 ||
                  incident.type === 16 ||
                  incident.type === 17 ||
                  incident.type === 29 ||
                  incident.type === 30
                "
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <img
                alt="logo"
                *ngIf="incident.type === 3 || incident.type === 4"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
            </ng-container>
          </div>
          <div class="flex gap-2 items-center" *ngIf="players.incidents">
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="incident.type === 9"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <div class="text-14" *ngIf="incident.type === 9">
                ({{
                  transform(
                    incident.out_player.id !== players.id
                      ? incident.out_player.name
                      : incident.in_player.name,
                    15
                  )
                }})
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="flex flex-col gap-5">
        <ng-container
          *ngFor="let players of lineUp.lineup.awaySubstitutes; let i = index"
        >
          <div class="flex flex-row-reverse gap-2 items-center">
            <div class="max-w-[20px] w-full text-16 text-grey-2">
              {{ players.shirt_number }}
            </div>
            <img
              alt="logo"
              class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
              [src]="players.logo"
            />
            <div class="text-14">
              {{ transform(players.name, 15) }}
            </div>
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="
                  (incident.player &&
                    incident.player.id === players.id &&
                    incident.type === 1) ||
                  incident.type === 8 ||
                  incident.type === 16 ||
                  incident.type === 17 ||
                  incident.type === 29 ||
                  incident.type === 30
                "
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <img
                alt="logo"
                *ngIf="incident.type === 3 || incident.type === 4"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
            </ng-container>
          </div>
          <div
            class="flex flex-row-reverse gap-2 items-center"
            *ngIf="players.incidents"
          >
            <ng-container *ngFor="let incident of players.incidents">
              <img
                alt="logo"
                *ngIf="incident.type === 9"
                class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] p-1 rounded-full border border-solid border-grey-15"
                [src]="iconIncidents[incident.type]"
              />
              <div class="text-14" *ngIf="incident.type === 9">
                ({{
                  transform(
                    incident.out_player.id !== players.id
                      ? incident.out_player.name
                      : incident.in_player.name,
                    15
                  )
                }})
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- MISSING PLAYERS -->
    <div
      class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3 mt-5"
    >
      {{ "MissingPlayers" | translate }}
    </div>
    <div class="grid grid-cols-2 gap-5">
      <div class="flex flex-col gap-5">
        <ng-container *ngFor="let players of lineUp.injury.home; let i = index">
          <div class="flex gap-2 items-center">
            <img
              alt="logo"
              class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
              [src]="players.logo"
            />
            <div class="text-14">
              {{ transform(players.name, 15) }}
              <span *ngIf="players.reason != ''">
                ({{ validReason(players.reason) | translate }})
              </span>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex flex-col gap-5">
        <ng-container *ngFor="let players of lineUp.injury.away; let i = index">
          <div class="flex flex-row-reverse gap-2 items-center">
            <img
              alt="logo"
              class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
              [src]="players.logo"
            />
            <div class="text-14">
              {{ transform(players.name, 15) }}
              <div class="text-grey-2">
                ({{ validReason(players.reason) | translate }})
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- COACHS -->
    <div
      class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3 mt-5"
    >
      {{ "Coachs" | translate }}
    </div>
    <div class="grid grid-cols-2 gap-5 mb-5">
      <div class="flex gap-2 items-center">
        <img
          alt="logo"
          class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
          [src]="lineUp.coachHome.logo"
        />
        <div class="text-14">
          {{ lineUp.coachHome.name }}
        </div>
        <img
          alt="logo"
          class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15 p-1"
          [src]="lineUp.coachHome.logoCountry"
        />
      </div>
      <div class="flex flex-row-reverse gap-2 items-center">
        <img
          alt="logo"
          class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
          [src]="lineUp.coachAway.logo"
        />
        <div class="text-14">
          {{ lineUp.coachAway.name }}
        </div>
        <img
          alt="logo"
          class="w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15 p-1"
          [src]="lineUp.coachAway.logoCountry"
        />
      </div>
    </div>
  </ng-container>

  <app-no-result
    *ngIf="!lineUp || (lineUp && !lineUp.status)"
    message="NotAvalaibleInformation"
  ></app-no-result>
</nz-skeleton>
